"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _ButtonGroup = _interopRequireDefault(require("@react/react-spectrum/ButtonGroup"));

var _Heading = _interopRequireDefault(require("@react/react-spectrum/Heading"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _UserCard = _interopRequireWildcard(require("../UserCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var FilterPopover = /*#__PURE__*/_react.default.forwardRef(function (_ref, firstFilterUserRef) {
  var ccxIngest = _ref.ccxIngest,
      commentsFilterClear = _ref.commentsFilterClear,
      commentsFilterTime = _ref.commentsFilterTime,
      commentsFilterUsers = _ref.commentsFilterUsers,
      filterTime = _ref.filterTime,
      filterUsers = _ref.filterUsers,
      filteredCommentsCount = _ref.filteredCommentsCount,
      intl = _ref.intl,
      toggleResolved = _ref.toggleResolved,
      touchControls = _ref.touchControls,
      users = _ref.users,
      showResolvedComments = _ref.showResolvedComments;
  var onTimeChange = (0, _react.useCallback)(function (values) {
    commentsFilterTime(values);
    ccxIngest.fireEvent(ccxIngest.events.filterTime);
  }, [ccxIngest, commentsFilterTime]);
  var onUsersChange = (0, _react.useCallback)(function (values) {
    commentsFilterUsers(values);
    ccxIngest.fireEvent(ccxIngest.events.filterUser);
  }, [ccxIngest, commentsFilterUsers]);
  var onClearFilters = (0, _react.useCallback)(function () {
    commentsFilterClear();
    ccxIngest.fireEvent(ccxIngest.events.clearFilters);
  }, [ccxIngest, commentsFilterClear]);
  var onToggleResolved = (0, _react.useCallback)(function () {
    toggleResolved();
    showResolvedComments ? ccxIngest.fireEvent(ccxIngest.events.backToUnresolved) : ccxIngest.fireEvent(ccxIngest.events.viewUnresolved);
  }, [ccxIngest, toggleResolved, showResolvedComments]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-scrollable"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-group"
  }, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    className: "filter-group-header",
    id: "ccx-filter--reviewer",
    variant: "subtitle2"
  }, intl.formatMessage({
    id: 'comments.filter.reviewers'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-group-content filter-group-content--names"
  }, /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, {
    "aria-labelledby": "ccx-filter--reviewer",
    "data-testid": "filter-users-group",
    multiple: true,
    onChange: onUsersChange,
    value: filterUsers
  }, users.map(function (user) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      key: user.id,
      ref: filterUsers[0] === user.id ? firstFilterUserRef : null,
      className: "filter-user-button",
      value: user.id,
      variant: "action"
    }, touchControls ? user.name : /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
      placement: "top",
      trigger: "hover"
    }, /*#__PURE__*/_react.default.createElement("span", null, user.name), /*#__PURE__*/_react.default.createElement(_UserCard.UserCardPopover, null, /*#__PURE__*/_react.default.createElement(_UserCard.default, {
      user: user
    }))));
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-group"
  }, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    className: "filter-group-header",
    id: "ccx-filter--time",
    variant: "subtitle2"
  }, intl.formatMessage({
    id: 'comments.filter.time'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-group-content filter-group-content--names"
  }, /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, {
    "aria-labelledby": "ccx-filter--time",
    "data-testid": "filter-time-group",
    multiple: true,
    onChange: onTimeChange,
    value: filterTime
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": intl.formatMessage({
      id: 'comments.arialabel.button.filterToday'
    }),
    value: "today",
    variant: "action"
  }, intl.formatMessage({
    id: 'comments.filter.today'
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": intl.formatMessage({
      id: 'comments.arialabel.button.filterYesterday'
    }),
    value: "yesterday",
    variant: "action"
  }, intl.formatMessage({
    id: 'comments.filter.yesterday'
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": intl.formatMessage({
      id: 'comments.arialabel.button.filterLastSevenDays'
    }),
    value: "last7Days",
    variant: "action"
  }, intl.formatMessage({
    id: 'comments.filter.last7.days'
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": intl.formatMessage({
      id: 'comments.arialabel.button.filterOlder'
    }),
    value: "older",
    variant: "action"
  }, intl.formatMessage({
    id: 'comments.filter.older'
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-group"
  }, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    className: "filter-group-header",
    variant: "subtitle2"
  }, intl.formatMessage({
    id: 'comments.filter.status'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-group-content filter-group-content--names"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": intl.formatMessage({
      id: 'comments.arialabel.button.filterResolved'
    }),
    "aria-pressed": showResolvedComments,
    className: "filter-resolved",
    "data-testid": "filter-resolved-button",
    onClick: onToggleResolved,
    selected: showResolvedComments,
    variant: "action"
  }, intl.formatMessage({
    id: 'comments.filter.resolved'
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-footer"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": intl.formatMessage({
      id: 'comments.arialabel.button.filterClear'
    }),
    className: "float-right filter-clear",
    "data-testid": "filter-clear-button",
    onClick: onClearFilters,
    quiet: true
  }, intl.formatMessage({
    id: 'comments.filter.clear'
  }))), /*#__PURE__*/_react.default.createElement("div", {
    "aria-live": "polite",
    className: "visually-hidden"
  }, intl.formatMessage({
    id: 'comments.ariaLive.filterResult'
  }, {
    count: filteredCommentsCount
  })));
});

FilterPopover.displayName = 'FilterPopover';
FilterPopover.defaultProps = {
  users: []
};
FilterPopover.propTypes = {
  ccxIngest: _propTypes.default.object.isRequired,
  commentsFilterClear: _propTypes.default.func.isRequired,
  commentsFilterTime: _propTypes.default.func.isRequired,
  commentsFilterUsers: _propTypes.default.func.isRequired,
  filteredCommentsCount: _propTypes.default.number.isRequired,
  filterTime: _propTypes.default.array.isRequired,
  filterUsers: _propTypes.default.array.isRequired,
  intl: _propTypes.default.object.isRequired,
  showResolvedComments: _propTypes.default.bool.isRequired,
  toggleResolved: _propTypes.default.func.isRequired,
  touchControls: _propTypes.default.bool.isRequired,
  users: _propTypes.default.array
};
var _default = FilterPopover;
exports.default = _default;